import * as Sentry from '@sentry/nuxt';

Sentry.init({
  dsn: "https://728c8a123f82a0dd1852d598636aa435@sentry.jagu.cz/85",
  environment: 'development',
  tracesSampleRate: 1.0,
});